
<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <button
        @click="decreaseNumber"
        @mousedown="whileMouseDown(decreaseNumber)"
        @mouseup="clearTimer"
        @touchstart="$event.preventDefault(); whileMouseDown(decreaseNumber)"
        @touchend="$event.preventDefault();clearTimer()"
        :class="buttonClass"
      >-</button>
    </div>
    <input
      type="text"
      v-bind:value="numericValue"
      @keypress="validateInput"
      @input="inputValue"
      :class="inputClass"
      :min="min"
      :max="max"
      debounce="500"
    />
    <div class="input-group-append">
      <button
        @click="increaseNumber"
        @mousedown="whileMouseDown(increaseNumber)"
        @mouseup="clearTimer"
        @touchstart="$event.preventDefault(); whileMouseDown(increaseNumber)"
        @touchend="$event.preventDefault();clearTimer()"
        :class="buttonClass"
      >+</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumberInputSpinner",

  data: function () {
    return {
      numericValue: this.value,
      timer: null,
    };
  },

  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      default: 0,
      type: Number,
    },
    max: {
      default: 10,
      type: Number,
    },
    step: {
      default: 1,
      type: Number,
    },
    mouseDownSpeed: {
      default: 100,
      type: Number,
    },
    inputClass: {
      default: "form-control form-control-sm text-center",
      type: String,
    },
    buttonClass: {
      default: "btn btn-default btn-sm",
      type: String,
    },
    integerOnly: {
      default: false,
      type: Boolean,
    },
  },

  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    whileMouseDown(callback) {
      if (this.timer === null) {
        this.timer = setInterval(() => {
          callback();
        }, this.mouseDownSpeed);
      }
    },

    increaseNumber() {
      this.numericValue += this.step;
    },

    decreaseNumber() {
      this.numericValue -= this.step;
    },

    isInteger(evt) {
      evt = evt ? evt : window.event;
      let key = evt.keyCode || evt.which;
      key = String.fromCharCode(key);
      const regex = /[0-9]/;

      if (!regex.test(key)) {
        evt.returnValue = false;
        if (evt.preventDefault) evt.preventDefault();
      }
    },

    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    validateInput(evt) {
      if (this.integerOnly === true) {
        this.isInteger(evt);
      } else {
        this.isNumber(evt);
      }
    },

    inputValue(evt) {
      this.numericValue = evt.target.value
        ? parseInt(evt.target.value)
        : this.min;
    },
  },

  watch: {
    numericValue: function (val, oldVal) {
      if (val <= this.min) {
        this.numericValue = parseInt(this.min);
      }

      if (val >= this.max) {
        this.numericValue = parseInt(this.max);
      }

      if (val <= this.max && val >= this.min) {
        this.$emit("input", val, oldVal);
      }
    },
  },
};
</script>

<style lang='scss' scoped>

.input-group .btn{
  min-width: 1.7rem;
}
</style>